module.exports = __webpack_public_path__ + "static/media/saintPaulLit.4abe4eba.png";